import React, { useCallback, useState } from 'react';
import DateTime from 'components/presentation/DateTime';
import Label from 'components/general/Label';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import {
    faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { useGetDisciplines } from 'helpers/commonCodes';
import { useEventUnit } from "components/common/EventUnit";


function PageHeader({ data, title, venue, dateTime, showEvent }) {
    const { mirs_competition, mirs_discipline, mirs_language, mirs_rsc } = useUrlFriendlyToParameters()
    const [showImage, setShowImage] = useState(mirs_discipline ? true : false);
    const dataDisciplines = useGetDisciplines({
        mirs_competition: mirs_competition,
        mirs_language: mirs_language
    })

    const eu = useEventUnit()

    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
    };
    const formatDateTime = Label({ data: 'LongDateTimeFormat' });
    //let discipline = getDiscipline(mirs_rsc);
    let competition = mirs_competition;

    let _title = title ? title : data?.results?.eventUnit?.description
    let _venue = venue ? venue : data?.results?.schedule?.venue?.description
    let _venueIcon = _venue ? <><FontAwesomeIcon className='' icon={faLocationDot} /> {_venue} - </> : ''
    let _dateTime = dateTime ? dateTime : data?.results?.schedule?.startDate
    let discipline = dataDisciplines?.disciplines?.find(item => item.code === mirs_discipline)?.description
    let event = showEvent ? eu(mirs_rsc, false) : ''
    event = event === '-' ? '' : event

    return (
        <>
            <div className='page-header-container'>
                <div className='container'>
                    {showImage ? (
                        <img aria-hidden="true"
                            src={`/assets/images/sports/${competition}/Dark/${mirs_discipline}.png`}
                            alt={discipline}
                            onError={hideImg}
                            className='img-fluid page-header-disciplina float-start' />
                    ) : (
                        ''
                    )}
                    <h1>{discipline} {discipline && '-'} {event} {_title}</h1>
                    {(_dateTime || _venueIcon) && <h2>{_venueIcon}<DateTime datetime={_dateTime} format={formatDateTime} /></h2>}

                </div>


            </div>
        </>
    )
}



function Updated() {
    const d = new Date();

    let time = d.getTime();
    return (
        <div>Last Refresh: <DateTime datetime={time} format={'HH:mm:ss'} /></div>
    )
}


export default PageHeader;